<nav class="navbar navbar-expand-lg fixed-top bg-dark" id="navbarMenu">
  <div class="container-fluid">
    <a class="navbar-brand" href="#">
      <span class="text-white">{{ title }}</span>
    </a>
    <button class="navbar-toggler bg-white" type="button"
    data-bs-toggle="collapse" data-bs-target="#navbarText"
    aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarText">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Usuarios</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Roles</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Grupos</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Permisos</span>
          </a>
        </li>
      </ul>
      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Datos</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Documentos</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Correos</span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" href="#">
            <span class="text-white">Telefonos</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
